import { getAxiosApiV2WithAuthorization } from '@clatter/platform';

const usersApi = {
  fetchUsers: () =>
    getAxiosApiV2WithAuthorization({
      url: `/user`,
      method: 'get',
    }),
  fetchUser: ({ userId }) =>
    getAxiosApiV2WithAuthorization({
      url: `/user/${userId}`,
      method: 'get',
    }),
  createUser: ({ data }) =>
    getAxiosApiV2WithAuthorization({
      url: `/v2/users`,
      method: 'POST',
      data: data,
      baseURL: process.env.NX_PUBLIC_CLATTER_ASSETS_SERVICE_API_URL,
    }),
  importUsers: ({ data }) =>
    getAxiosApiV2WithAuthorization({
      url: `/user/import`,
      method: 'POST',
      data: data,
    }),
  updateUser: ({ userId, data }) =>
    getAxiosApiV2WithAuthorization({
      url: `/v2/users/${userId}`,
      method: 'PATCH',
      data: data,
      baseURL: process.env.NX_PUBLIC_CLATTER_ASSETS_SERVICE_API_URL,
    }),
  sendVerificationEmail: ({ userId }) =>
    getAxiosApiV2WithAuthorization({
      url: `/user/${userId}/email-verify-requests`,
      method: 'POST',
    }),
  deleteUser: ({ userId }) =>
    getAxiosApiV2WithAuthorization({
      url: `/user/${userId}`,
      method: 'DELETE',
    }),
};

export default usersApi;
